// Events reducer types
export const SET_EVENTS = 'SET_EVENTS';
export const GET_EVENT = 'GET_EVENT';
export const POST_EVENT = 'POST_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const LIKE_EVENT = 'LIKE_EVENT';
export const UNLIKE_EVENT = 'UNLIKE_EVENT';
export const SUBMIT_COMMENT = 'SUBMIT_COMMENT';
export const JOIN_EVENT = 'JOIN_EVENT';
export const LEAVE_EVENT = 'LEAVE_EVENT';
export const EDIT_EVENT = 'EDIT_EVENT';
export const INVITE_FOR_EVENT = 'INVITE_FOR_EVENT';
export const REMOVE_EVENT_INVITE = 'REMOVE_EVENT_INVITE';
